import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-time-projects-wo',
  templateUrl: './time-projects-wo.component.html',
  styleUrls: ['./time-projects-wo.component.css']
})
export class TimeProjectsWoComponent implements OnInit {
    projectKeyno;

    public itemsListWorkingOrders: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.projectKeyno = this.stateService.getStateParams()['project_keyno'];
    }

    private async loadWorkingOrders() {
        if (!!this.projectKeyno) {
            this.itemsListWorkingOrders = await this.datatask.Post(27, {
                cust_name: 'ALL',
                cust_no: '0',
                project_keyno: this.projectKeyno,
                ok: '0'
            });
        }
    }

    private async init() {
        this.loadWorkingOrders();
    }

    ngOnInit() {
        this.init();
    }
}
